import { Stack } from '@mui/material'
import React from 'react'
import RoiBoostButton from '../Table/RoiBoostButton';
import { MatchupInfo } from '../store/types';
import BoostOwnershipArrow from './BoostOwnershipArrow';

const Game = ({ matchupInfo, boostable, boostOwnership, removedTeams, boostedValue, disableRemove, onRemove, onBoost }: { matchupInfo: MatchupInfo, boostOwnership?: boolean, boostable?: boolean, disableRemove: boolean, boostedValue?: { [key: string]: number }, removedTeams: string[], onRemove: (team: string) => void, onBoost: (team: string, percent: number) => void }) => {
  const { homeTeamAbbrev, homeTeamTitle, awayTeamAbbrev, awayTeamTitle, gameTime } = matchupInfo;


  return (
    <Stack direction='row' alignItems='center' py="10px" bgcolor="#1C1C1C" borderRadius='10px' width='100%'>
      <Stack direction='column' rowGap={1} flexGrow={1} justifyContent='space-between' height='100%'>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack direction='row' alignItems='center'>
            {
              !disableRemove && (
                <Stack ml="8px" sx={{ cursor: 'pointer', marginRight: 1 }} onClick={() => onRemove(awayTeamAbbrev)}>
                  {
                    removedTeams.length > 0 && removedTeams?.includes(awayTeamAbbrev) ? <AddIcon /> : <RemoveIcon />
                  }
                </Stack>

              )
            }
            {matchupInfo.awayTeamLogo && 
              <Stack mx="8px">
                <img src={matchupInfo.awayTeamLogo} alt={matchupInfo.awayTeamAbbrev} width={20} height={20} style={{ objectFit: 'contain' }} />
              </Stack>            
            }
            <Stack fontSize='12px' fontWeight={700} color='rgba(255, 255, 255, .7)' mr="2px">{awayTeamAbbrev}</Stack>
            <Stack fontSize='14px' fontWeight={700} color='#FFF'> {awayTeamTitle}</Stack>
          </Stack>
          {
            boostable && (
              <Stack width={200} paddingRight='12px'>
                <RoiBoostButton
                  defaultPercent={boostedValue && boostedValue[awayTeamAbbrev] !== undefined ? boostedValue[awayTeamAbbrev] * 100 : 0}
                  onChange={(percent) => onBoost(awayTeamAbbrev, percent)}
                  previousPercent={0}
                  constantMax={10000}
                  constantMin={-10000}
                  changeOverride={1}
                />
              </Stack>
            )
          }
          {
            boostOwnership && (
              <BoostOwnershipArrow team={awayTeamAbbrev} boostedValue={boostedValue || {}} onBoost={onBoost} />
            )
          }
        </Stack>
        <Stack direction='row' alignItems='center' ml="16px" color='rgba(255,255,255,.87)' fontSize='10px' fontWeight={300}>
          @
          <Stack sx={{
            color: 'rgba(255, 255, 255, 0.70)',
            fontSize: '10px',
            fontWeight: 300,
            borderRadius: '4px',
            padding: '4px',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            whiteSpace: 'nowrap',
            mx: '4px',
          }}>
            {new Date(gameTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} EST
          </Stack>
        </Stack>
        <Stack direction='row' justifyContent='space-between' alignItems='center'>
          <Stack direction='row' alignItems='center'>
          {
              !disableRemove && (
                <Stack ml='8px' sx={{ cursor: 'pointer', marginRight: 1 }} onClick={() => onRemove(homeTeamAbbrev)}>
                  {
                    removedTeams.length > 0 && removedTeams?.includes(homeTeamAbbrev) ? <AddIcon /> : <RemoveIcon />
                  }
                </Stack>
              )
            }
            {matchupInfo.homeTeamLogo && 
              <Stack mx="8px">
                <img src={matchupInfo.homeTeamLogo} alt={matchupInfo.homeTeamAbbrev} width={20} height={20} />
              </Stack>
            }
            <Stack fontSize='12px' fontWeight={700} color='rgba(255, 255, 255, .7)' mr="2px">{homeTeamAbbrev}</Stack>
            <Stack fontSize='14px' fontWeight={700} color='#FFF'> {homeTeamTitle}</Stack>
          </Stack>
          {
            boostable && (
              <Stack width={200} paddingRight='12px'>
                <RoiBoostButton
                  defaultPercent={boostedValue && boostedValue[homeTeamAbbrev] !== undefined ? boostedValue[homeTeamAbbrev] * 100 : 0}
                  onChange={(percent) => onBoost(homeTeamAbbrev, percent)}
                  previousPercent={0}
                  constantMax={10000}
                  constantMin={-10000}
                  changeOverride={1}
                />
              </Stack>
            )
          }
          {
            boostOwnership && (
              <BoostOwnershipArrow team={homeTeamAbbrev} boostedValue={boostedValue || {}} onBoost={onBoost} />
            )
          }
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Game

const RemoveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <rect width="20" height="20" rx="10" fill="#A10012" fillOpacity="0.1" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#A10012" strokeOpacity="0.5" />
    <path d="M4.16663 10.625V9.375H15.8333V10.625H4.16663Z" fill="#A10012" />
  </svg>
)

const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#007636" fillOpacity="0.15" />
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#007636" />
    <path d="M7.66667 8.33333H4.33333C4.23889 8.33333 4.15972 8.30134 4.09583 8.23737C4.03194 8.1734 4 8.09413 4 7.99955C4 7.90497 4.03194 7.82585 4.09583 7.76218C4.15972 7.69851 4.23889 7.66667 4.33333 7.66667H7.66667V4.33333C7.66667 4.23889 7.69866 4.15972 7.76263 4.09583C7.8266 4.03194 7.90587 4 8.00045 4C8.09503 4 8.17415 4.03194 8.23782 4.09583C8.3015 4.15972 8.33333 4.23889 8.33333 4.33333V7.66667H11.6667C11.7611 7.66667 11.8403 7.69866 11.9042 7.76263C11.9681 7.8266 12 7.90587 12 8.00045C12 8.09503 11.9681 8.17415 11.9042 8.23782C11.8403 8.3015 11.7611 8.33333 11.6667 8.33333H8.33333V11.6667C8.33333 11.7611 8.30134 11.8403 8.23737 11.9042C8.1734 11.9681 8.09413 12 7.99955 12C7.90497 12 7.82585 11.9681 7.76218 11.9042C7.69851 11.8403 7.66667 11.7611 7.66667 11.6667V8.33333Z" fill="#007636" />
  </svg>
)